import "../scss/index.scss";
import "./prism.js";

(window as any).kbase = {
    tree: {
        toggleGroupOpened: function (id: string) {
            let el = document.getElementById(`tree-group-${id}`);
            if (el) {
                el.classList.toggle('opened');
            }
        }
    }
}

function calculateCssVariables(repeat: number) {
    let root: HTMLElement | null = document.getElementById("knowledge-base-content-root");
    if (root) {

        let header: HTMLElement | null = document.getElementById("knowledge-base-header");
        if (!header) {
            if (repeat < 10) {
                setTimeout(() => calculateCssVariables(repeat + 1), 10);
            }
        }
        let height = 0;
        if (header) {
            height = header.getBoundingClientRect().height;
        }


        root.style.setProperty("--kb-root-margin-top", `${parseInt((root.getBoundingClientRect().top + window.scrollY).toString())}px`);
        root.style.setProperty("--kb-header-height", `${parseInt(height.toString())}px`);
    }
}

calculateCssVariables(0);
setInterval(() => calculateCssVariables(0), 1000);